<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 11/10/2021
  -->

<template>
	<div>
		<div v-if="isActive" class="row mx-0">
			<div class="text-success">
				active
			</div>
			<div class="layout-spacer"/>
			<div>
				<a :href="stripeManageUrl" target="_blank">
					Manage in Stripe
				</a>
			</div>

			<ToolTipView>
				Your client is subscribed to this program.
				<br/>
				<br/>
				They will be billed according to the schedule above.
			</ToolTipView>


		</div>
		<div v-else-if="isCancelled">
			<span class="text-warning">
				cancelled
			</span>

			<ToolTipView>
				This subscription is cancelled and your clinet won't be charged anymore
			</ToolTipView>
		</div>
		<span v-else-if="isPaymentFailed">
			<span class="text-danger">
				payment failed
			</span>
			<ToolTipView>
				We tried to charge your client but their bank declined the transaction
				<br/>
				<br/>
				Please contact your client asking them to check their payment method.
			</ToolTipView>
		</span>
		<span v-else>
			<span class="text-warning">
				waiting for client's consent
			</span>
			<ToolTipView>
				Your client will be presented with a consent form before they can access their coaching materials.
				<br/>
				<br/>
				The consent form will also collect their credit card information and they will be charged automatically based on the schedule you set up above.
			</ToolTipView>

		</span>


	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import SubscriptionStatusEnum from "@shared/Billing/SubscriptionStatusEnum";
import RecurringBillingItem from "@shared/Billing/RecurringBillingItem";

export default {
	name: "SubscriptionStatusView",
	components: {ToolTipView},
	extends: BaseComponent,

	props: {
		recurringBillingItem: {RecurringBillingItem, requried: true},
	},

	computed: {
		status(){
			return this.recurringBillingItem.subscriptionStatus
		},
		isNotStarted() {
			return this.status == "" || this.status === SubscriptionStatusEnum.NOT_SET
		},
		isActive() {
			return this.status === SubscriptionStatusEnum.ACTIVE
		},

		isCancelled(){
			return this.status === SubscriptionStatusEnum.CANCELED
		},
		isPaymentFailed(){
			return this.status === SubscriptionStatusEnum.INCOMPLETE
				|| this.status === SubscriptionStatusEnum.PAST_DUE
				|| this.status === SubscriptionStatusEnum.UNPAID
				|| this.status === SubscriptionStatusEnum.INCOMPLETE_EXPIRED
		},

		stripeManageUrl(){
			return 'https://dashboard.stripe.com/test/subscriptions/' + this.recurringBillingItem.stripeSubscriptionId
		}
	},
}
</script>

<style lang="scss">

</style>
